import { FC } from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@matrix-forge/ui/components/select';
import { cn } from '@matrix-forge/ui/lib/utils';

interface AgentSelectProps {
  className?: string;
  value: string;
  agents?: { id: string; name: string }[] | null;
  placeholder?: string;
  onValueChange: (nextValue: string) => any;
}

export const AgentSelect: FC<AgentSelectProps> = ({
  className,
  value,
  agents,
  placeholder = 'Select...',
  onValueChange,
}) => (
  <Select value={value} onValueChange={onValueChange}>
    <SelectTrigger className={cn('histogram-select', className)}>
      <SelectValue placeholder={placeholder} />
    </SelectTrigger>
    <SelectContent>
      {(agents || []).map(({ id, name }) => (
        <SelectItem key={id} value={id}>
          {name}
        </SelectItem>
      ))}
    </SelectContent>
  </Select>
);
